
// import { Link } from "react-router-dom";
// import { motion } from "framer-motion";

const projects = [
  {
    title: "Scratchpad",
    description: "A local-first AI workspace built with Go, combining Retrieval-Augmented Generation (RAG), persistent project memory, document intelligence, and web research into a modular, portable development environment.",
    link: "https://techtrail.tuhindutta.com/building-scratchpad-rethinking-the-local-ai-workspace"
  },
  {
    title: "Zenalyze",
    description: "An AI-assisted data analysis tool that generates and executes real Python code using LLMs for tasks like exploration and plotting, while keeping data local and secure.",
    link: "https://tuhindutta.github.io/Zenalyze/" ,
  },
  {
    title: "FusionQA",
    description: "A hybrid framework/API that combines semantic vector search with knowledge graph reasoning to deliver accurate, context-aware answers from unstructured documents.",
    link: "https://tuhindutta.github.io/FusionQA/" ,
  },
  {
    title: "GestureForge – A Static and Dynamic Hand Gesture Model Training Framework",
    description: "Train and validate landmark-based hand gesture recognition models from images or video sequences using a unified and extensible pipeline.",
    link: "https://tuhindutta.github.io/GestureForge/" ,
  },
  {
    title: "Virtual Tuhin: AI-Powered Digital Twin",
    description: "A RAG-based digital twin chatbot of myself, built with all-mpnet-base-v2 embeddings, FAISS vector store, and LLaMA 3-70B, deployed via Streamlit on Hugging Face.",
    link: "https://tuhindutta.github.io/Virtual-Twin/" ,
  },
  {
    title: "Custom Transformer Training Library",
    description: "Built a flexible Python package for training customized Transformer/GPT models from scratch, offering deep transparency and control.",
    link: "https://tuhindutta.github.io/Bumblebee/" ,
  },
  {
    title: "Real-time Facial Emotion Recognition",
    description: "Developed an AI app that identifies multiple individuals’ emotions simultaneously from live video feeds.",
    link: "https://tuhindutta.github.io/Emotion-Detection-App/",
  },
  {
    title: "Gesture-Based Device Control",
    description: "Developed computer vision applications to control mouse actions and system volume using intuitive hand gestures with OpenCV and Mediapipe.",
    link: "https://tuhindutta.github.io/Gesture-Control/",
  },
  {
    title: "Movie Recommendation System",
    description: "Designed a personalized movie recommender app utilizing TMDB API and user preference modeling.",
    link: "https://tuhindutta.github.io/Movie-Recommendation-System/",
  },
  {
    title: "Face Recognition from Static Images",
    description: "Built a facial recognition system to detect and match labeled faces within group images.",
    link: "https://tuhindutta.github.io/Face-Recognition/",
  },
  {
    title: "Politeness Engine - Speech Refiner",
    description: "A LLM powered a modern Electron desktop app that transcribes user audio, and refines impolite sentences into polite responses while preserving original context and intent.",
    link: "https://tuhindutta.github.io/Speech-Refiner/",
  },
  {
    title: "Nutriguide API – AI-Powered Personalized Nutrition Guidance",
    description: "An API that uses a user’s health profile and product nutritional data to provide interactive, personalized dietary recommendations via an LLM-powered chatbot.",
    link: "https://tuhindutta.github.io/nutriguide/" ,
  },
  {
    title: "Smart Nutrition API – K8s Deployment",
    description: "A containerized REST API that extracts structured nutritional data from food label images using OCR, search, and LLMs. Deployed on Kubernetes with Docker and Minikube for scalable and portable access.",
    link: "https://tuhindutta.github.io/smart-nutrition-api/" ,
  },
];

function Projects() {
  return (
    // <section id="projects" className="min-h-screen bg-white text-gray-800 px-4 sm:px-6 py-16">
    <section
      id="projects"
      name="projects"
      className="bg-projects min-h-screen bg-white text-gray-800 px-2 py-16">
      {/* <div className="max-w-6xl mx-auto text-center relative"> */}
      <div className="site-container text-center">

        <h2 className="text-2xl sm:text-3xl font-bold title-color mb-6">
          <u>Open Source Projects</u>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 text-left">
          {projects.map((project) => (
            <article
              key={project.title}
              className="tile-color flex h-full flex-col gap-4 p-5 sm:p-6"
            >
              <h3 className="text-lg font-semibold leading-snug text-blue-800">
                {project.title}
              </h3>
              <p className="flex-1 text-sm leading-relaxed text-gray-700">
                {project.description}
              </p>
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm font-semibold text-blue-700 hover:text-blue-900"
              >
                View project <span aria-hidden="true">↗</span>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;